
<template>
  <!--文档管理-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="articleId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
    </x-tabula>

    <!--查看链接的弹窗-->
    <a-modal
      title="查看链接"
      :visible="visible"
      @cancel="closeModal"
      @ok="visible=false"
      :width="550"
      v-bind="$store.state.modalDetailConfig"
    >
    <!-- v-bind="$store.state.modal_ItemLayout" -->
      <a-form-item >
        <a-row type="flex" :gutter="10">
          <a-col span="18">
            <a-input id="link" v-model="link" placeholder=""></a-input>
          </a-col>
          <a-col>
            <a-button class="link" data-clipboard-target="#link" type="primary">复制</a-button>
          </a-col>
        </a-row>
      </a-form-item>
    </a-modal>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
import ClipboardJS from 'clipboard';
export default {
  mixins: [fetchSelect],
  name: 'document',
  data () {
    return {
      link: '',
      visible: false,
      searchList: [
        { props: ['title'], placeholder: '输入标题', inputType: 'input' },
        // eslint-disable-next-line
        { props: ['categoryId'], placeholder: '选择分类', options: [], inputType: 'cascader', changeOnSelect: true,
          fieldNames: {label: 'label', value: 'value', children: 'children'}
        }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', permi: ['community:article:add'] }
      ],
      rowOptList: [
        { text: '修改', handle: (record) => this.$refs.table.toEdit(record), permi: ['community:article:edit'] },
        { text: '删除', handle: (record) => this.$refs.table.showDeleteConfirm(record), permi: ['community:article:remove'] },
        { text: '链接', handle: record => this.showLink(record), permi: ['community:article:link']}
      ],
      columns: [
        { title: '标题', dataIndex: 'title', align: 'left', width: '' },
        { title: '应用位置', dataIndex: 'applicationLocation', align: 'left', width: '' },
        // { title: '浏览次数', dataIndex: 'view_num', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        title: '',
        categoryId: ''
      },
      listApi: {
        url: '/article/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addDocument',
        addTitle: '新增文档',
        editTitle: '修改文档'
      },
      deleteParam: {
        url: '/article/',
        title: '文档',
        key: 'title'
      }
    };
  },
  created () {
    this.$get({
      url: '/category/treeselectAll'
    }).then(({data}) => {
      this.searchList[1].options = data;
    });
  },
  methods: {
    closeModal () {
      this.visible = false;
      this.instance.destroy();
    },
    /** 查看链接 */
    showLink (record) {
      this.link = record.viewUrl;
      this.visible = true;

      this.$nextTick(() => {
        this.instance = new ClipboardJS('.link');
        this.instance.on('success', (e) => {
          this.$message.success('复制成功');
          e.clearSelection();
        });

        this.instance.on('error', (e) => {
          this.$message.error('复制失败');
        });
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>
